var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-badge",class:{ [_vm.badge.toLowerCase().replace(' ', '-')]: _vm.badge }},[_vm._v("\n  "+_vm._s(_vm.badge)+"\n  "),(_vm.tooltip)?_c('Tooltip',[_vm._v("\n    "+_vm._s(_vm.tooltip)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }